import { compose } from 'recompose'
import { connect } from 'react-redux'
import { getWaiter } from 'redux-waiter'
import { withRouter } from 'react-router'

import { actions, selectors } from '../'
import { WAITER_GET_EMPLOYEE_BENEFITS } from '../constants'

const mapStateToProps = (state, props) => {
  const employeePublicKeyParam = props.params.id
  const waivedBenefitList = selectors.getWaivedBenefits(state)
  const gettingWaivedBenefitList = getWaiter(
    state,
    `${WAITER_GET_EMPLOYEE_BENEFITS}${employeePublicKeyParam}`
  ).isPending
  return {
    waivedBenefitList,
    gettingWaivedBenefitList,
  }
}

const mapDispatchToProps = (dispatch) => ({
  getWaivedBenefits: (EmployeePublicKey, EffectiveOn) => {
    dispatch(actions.getEmployeeBenefits(EmployeePublicKey, EffectiveOn))
  },
  clearAll: () => {
    dispatch(actions.clearAll())
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))
